module.exports = __webpack_public_path__ + "img/19.6413b8c6.png";